import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { LoginPage } from '@/pages/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { CredentialsPage } from '@/pages/CredentialsPage';
import { TemplatesPage } from '@/pages/TemplatesPage';
import { ContactsPage } from '@/pages/ContactsPage';
import { CampaignsPage } from '@/pages/CampaignsPage';
import { CampaignDetailPage } from '@/pages/CampaignDetailPage';
import { DispatchesPage } from '@/pages/DispatchesPage';
import { AdminTenantsPage } from '@/pages/AdminTenantsPage';
import { UplogSettingsPage } from '@/pages/UplogSettingsPage';
import { RcsSettingsPage } from '@/pages/RcsSettingsPage';
import { RcsCampaignDetailPage } from '@/pages/RcsCampaignDetailPage';
import { ProtectedSuperadminRoute } from '@/components/auth/ProtectedSuperadminRoute';
import { NotFoundPage } from '@/pages/NotFoundPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/', element: <DashboardPage /> },
          { path: '/credentials', element: <CredentialsPage /> },
          { path: '/templates', element: <TemplatesPage /> },
          { path: '/contacts', element: <ContactsPage /> },
          { path: '/campaigns', element: <CampaignsPage /> },
          { path: '/campaigns/:id', element: <CampaignDetailPage /> },
          { path: '/dispatches', element: <DispatchesPage /> },
          { path: '/uplog', element: <UplogSettingsPage /> },
          { path: '/rcs', element: <RcsSettingsPage /> },
          { path: '/rcs/campaigns/:id', element: <RcsCampaignDetailPage /> },
          {
            path: '/admin',
            element: (
              <ProtectedSuperadminRoute>
                <AdminTenantsPage />
              </ProtectedSuperadminRoute>
            ),
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
